export default function subjectivitiesReducer(
    state: any = {
        extend: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        subjectivities: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        markSubjectivitiesAsCompleted: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        cancelPolicy: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Subjectivities reducer
         */
        case 'EXTEND_SUBJECTIVITY_PENDING': {
            return { ...state, extend: { loading: true, success: null } }
        }

        case 'EXTEND_SUBJECTIVITY_REJECTED': {
            return { ...state, extend: { loading: false, error: action.payload, success: false } }
        }

        case 'EXTEND_SUBJECTIVITY_FULFILLED': {
            return { ...state, extend: { loading: false, done: true, error: null, response: action.payload } }
        }

        /**
         *     Subjectivities reducer
         */
        case 'GET_SUBJECTIVITY_PENDING': {
            return { ...state, subjectivities: { loading: true, success: null } }
        }

        case 'GET_SUBJECTIVITY_REJECTED': {
            return { ...state, subjectivities: { loading: false, error: action.payload, success: false } }
        }

        case 'GET_SUBJECTIVITY_FULFILLED': {
            return { ...state, subjectivities: { loading: false, done: true, error: null, response: action.payload } }
        }

        /**
         *     Subjectivities reducer
         */
        case 'MARK_SUBJECTIVITY_AS_COMPLETED_PENDING': {
            return {
                ...state,
                markSubjectivitiesAsCompleted: { loading: true, success: null },
            }
        }

        case 'MARK_SUBJECTIVITY_AS_COMPLETED_REJECTED': {
            return {
                ...state,
                markSubjectivitiesAsCompleted: { loading: false, error: action.payload, success: false },
            }
        }

        case 'MARK_SUBJECTIVITY_AS_COMPLETED_FULFILLED': {
            return {
                ...state,
                markSubjectivitiesAsCompleted: { loading: false, done: true, error: null, response: action.payload },
            }
        }

        /**
         *     CancelPolicy reducer
         */
        case 'CANCEL_POLICY_PENDING': {
            return {
                ...state,
                cancelPolicy: { loading: true, success: null },
            }
        }

        case 'CANCEL_POLICY_REJECTED': {
            return {
                ...state,
                cancelPolicy: { loading: false, error: action.payload, success: false },
            }
        }

        case 'CANCEL_POLICY_FULFILLED': {
            return {
                ...state,
                cancelPolicy: { loading: false, done: true, error: null, response: action.payload },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/subjectivities.ts